// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2ZiOy","inputDescription":"styles_inputDescription__not6i"};